import { Table } from "@/features/Table";
import { useLocation } from "react-router";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";
import {
  type S1InvestStrategies,
  s1_invest_strategies_columns,
} from "./columns";
import {
  type FilterS1InvestStrategiesSchema,
  FilterS1InvestStrategies,
} from "./filter";

export const S1InvestStrategiesTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<S1InvestStrategies, FilterS1InvestStrategiesSchema>
      label="S1 Invest strategies"
      client={Clients.S1_QUANTILIA}
      table_name={Tables.S1_INVEST_STRATEGIES}
      columns={s1_invest_strategies_columns}
      filter={<FilterS1InvestStrategies />}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
